import { registerTourPage } from '@/composables/tour/tourRegistry';
import { step, introStep } from '@/composables/tour/stepHelpers';

registerTourPage('admin-tickets', {
  key: 'admin-tickets',
  label: 'Support Dashboard',
  getSteps: () => [
    step({
      target: '#tour-tickets-actions',
      title: 'Settings',
      content:
        'Configure ticket categories, SLAs, and the auto-response message that goes out when a ticket is created.',
      placement: 'left',
    }),
    step({
      target: '#tour-tickets-filters',
      title: 'Find Tickets',
      content:
        'Filter the queue by status, priority, or category. Apply once you\'ve set the filters you need.',
      placement: 'bottom',
    }),
    step({
      target: '#tour-tickets-table',
      title: 'Ticket Queue',
      content:
        'Every open and resolved ticket. Click a subject to open the ticket and reply, change status, assign, or close it.',
      placement: 'top',
    }),
  ],
});

registerTourPage('admin-tickets-settings', {
  key: 'admin-tickets-settings',
  label: 'Ticket Settings',
  getSteps: () => [
    introStep({
      title: 'Ticket Settings',
      content:
        'On the left, set the global auto-response that goes out for any new ticket. On the right, manage categories — each can carry its own auto-response, default priority, and SLA.',
    }),
  ],
});

registerTourPage('admin-ticket-detail', {
  key: 'admin-ticket-detail',
  label: 'Ticket Detail',
  getSteps: () => [
    introStep({
      title: 'Ticket Detail',
      content:
        'The full conversation, attachments, and the side panel where you change status, set priority, assign to a teammate, or close the ticket. Replies post into the timeline below.',
    }),
  ],
});
